<!--
 * @Description: 页面主构架（登录后的主页面）
 * @Author: laoliu
 * @Date: 2021-02-08 09:11:25
-->
<!--
 * 
 *    ┏┓　　　┏┓
 *  ┏┛┻━━━┛┻┓
 *  ┃　　　　　　　┃
 *  ┃　　　━　　　┃
 *  ┃　＞　　　＜　┃
 *  ┃　　　　　　　┃
 *  ┃...　⌒　...　┃
 *  ┃　　　　　　　┃
 *  ┗━┓　　　┏━┛
 *      ┃　　　┃　
 *      ┃　　　┃
 *      ┃　　　┃
 *      ┃　　　┃  神兽保佑
 *      ┃　　　┃  代码无bug　　
 *      ┃　　　┃
 *      ┃　　　┗━━━┓
 *      ┃　　　　　　　┣┓
 *      ┃　　　　　　　┏┛
 *      ┗┓┓┏━┳┓┏┛
 *        ┃┫┫　┃┫┫
 *        ┗┻┛　┗┻┛
 -->
<template>
  <el-container>
    <el-header height="60px"><app-header/></el-header>
    <el-container>
      <el-aside width="163px" :style="dynamicHeight">
        <app-aside v-bind:activeIndex="activeIndex"/>
      </el-aside>
      <el-main :style="dynamicHeight"><app-content ref="main" @activeIndex="handleActiveIndex" /></el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from './components/Header'
import Aside from './components/Aside'
import Content from './components/Content'

export default {
  name: 'PageFrame',
  data() {
    return {
      activeIndex:"",
    }
  },

  components: {
    'app-header' : Header,
    'app-aside'  : Aside,
    'app-content': Content
  },

  computed: {
    dynamicHeight() {
      return 'height:' + (this.$root.windowHeight - 90) + 'px';
    },
  },

  methods:{
    handleActiveIndex(activeIndex) {
      this.activeIndex = activeIndex;
    },
  },
}
</script>

<style>
.el-container {
  border: solid yellow 0px;
}
.el-header {
  margin-bottom: 0;
  padding: 0;
  color: #333;
  border-bottom: solid #f2f3f4 8px;
}
.el-aside {
  margin-top: 0;
  color: #333;
  border-right: solid #f2f3f4 8px;
}
.el-main {
  margin: 0;
  padding: 0;
  color: #333;
  border: solid black 0px;
} 
</style>


// WEBPACK FOOTER //
// src/components/pageframe/PageFrame.vue